var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"main-container"},[_c('div',[_c('the-sidebar',{attrs:{"user":_vm.user}}),_c('el-container',{staticClass:"right-side"},[(_vm.plan !== null)?_c('the-header'):_vm._e(),_c('router-view')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }